import styles from './CourseFAQ.module.css'
import Link from 'next/link'

export default () => (
  <div className={styles.CourseFAQ}>
    Have a question about how the courses work? Read the{' '}
    <Link
      href="/courses/faq"
      title="Cypress courses frequently asked questions"
    >
      frequently asked questions
    </Link>
    .
  </div>
)
